import './productDetailCarousel.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Grid, Carousel } from '../base';
import CloudinaryPicture from './cloudinaryPicture';

const ProductDetailCarousel = forwardRef((props, ref) => {
  const bigClassName = classNames({
    rounded: props.rounded,
  });

  const thumbClassName = classNames({
    'w-100': true,
    rounded: props.rounded,
  });

  return (
    <Carousel
      ref={ref}
      className="carousel-product-images"
      totalSlides={props.images.length}
      isPlaying
      infinite
      visibleSlides={1}
    >
      <Carousel.Slider className="mb-3">
        {props.images.map((image, index) => (
          <Carousel.Slide key={image} ref={ref} index={index}>
            <CloudinaryPicture
              prefix={props.prefix}
              imageKey={image}
              className={bigClassName}
              type="big"
            />
          </Carousel.Slide>
        ))}
      </Carousel.Slider>

      <Grid.Row className="link-thumb-row">
        {props.images.map((image, index) => (
          <Grid.Col key={image} className="col link-thumb-col">
            <Carousel.Dot slide={index}>
              <CloudinaryPicture
                prefix={props.prefix}
                imageKey={image}
                className={thumbClassName}
                type="small"
              />
            </Carousel.Dot>
          </Grid.Col>
        ))}
      </Grid.Row>
    </Carousel>
  );
});

ProductDetailCarousel.propTypes = {
  prefix: PropTypes.string,
  images: PropTypes.array,
  rounded: PropTypes.bool,
};

ProductDetailCarousel.defaultProps = {
  prefix: 'products/',
  images: [],
  rounded: false,
};

export default ProductDetailCarousel;
